module.exports = __webpack_public_path__ + "img/cloud-icon.7716a6c8.png";